module.exports = __webpack_public_path__ + "static/media/7.9537991.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/test/7.wav
// module id = 5Vut
// module chunks = 0